import React from "react";
import Image from "gatsby-image";
import {
  Container,
  Title,
  Subtitle,
  ImageContainer,
  Content,
} from "./Components";

const Header = ({ title, subtitle, image, margin }) => {
  return (
    <Container>
      <ImageContainer>
        <Image
          style={{
            width: '100%',
            height: '100%',
            minHeight: '180px',
            maxHeight: '300px',
          }}
          fluid={image.childImageSharp.fluid}
        />
      </ImageContainer>
      <Content margin={margin}>
        <Subtitle>{subtitle}</Subtitle>
        <Title>{title}</Title>
      </Content   >
    </Container>
  );
};

export default Header;
